var map = {
	"./air-nga-en/assets/top-picks-nav-icon-active.png": 40249,
	"./ais-tai-en/assets/top-picks-nav-icon-active.png": 72756,
	"./ais-tai-tha/assets/top-picks-nav-icon-active.png": 23128,
	"./demo-arabic/assets/top-picks-nav-icon-active.png": 6784,
	"./demo-et-en/assets/top-picks-nav-icon-active.png": 71077,
	"./demo-romanian/assets/top-picks-nav-icon-active.png": 99119,
	"./demo-um-en/assets/top-picks-nav-icon-active.png": 62368,
	"./dtac-tai-en/assets/top-picks-nav-icon-active.png": 17455,
	"./dtac-tai-tha/assets/top-picks-nav-icon-active.png": 59521,
	"./ethiotel-et-amh/assets/top-picks-nav-icon-active.png": 1251,
	"./ethiotel-et-en/assets/top-picks-nav-icon-active.png": 3442,
	"./mtn-cg-fr/assets/top-picks-nav-icon-active.png": 38363,
	"./mtn-ci-fr/assets/top-picks-nav-icon-active.png": 31089,
	"./mtn-cmr-fr/assets/top-picks-nav-icon-active.png": 63581,
	"./mtn-gha-en/assets/top-picks-nav-icon-active.png": 85034,
	"./mtn-nga-en/assets/top-picks-nav-icon-active.png": 36102,
	"./mtn-zam-en/assets/top-picks-nav-icon-active.png": 44832,
	"./saf-ke-en/assets/top-picks-nav-icon-active.png": 12013,
	"./saudi-uae-en/assets/top-picks-nav-icon-active.png": 26832,
	"./tlk-za-en/assets/top-picks-nav-icon-active.png": 33401,
	"./vc-za-en/assets/top-picks-nav-icon-active.png": 7613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90495;